// extracted by mini-css-extract-plugin
export default {"cellAlign":"cellAlign---F4i58"};